import { IFirmType } from "./../../models/IFirmType";

export class FirmsTypesListState {
  firmTypeList: IFirmType[] = [];
}
